// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"b65dc1f1","171":"a46e0598","219":"0a19268e","518":"7f28efbd","529":"795bff4e","552":"756b0b2c","640":"1f42e53c","691":"ef3c4556","737":"90ccd4aa","927":"1e8cc2e1","931":"d444661b"}[chunkId] + ".chunk.js";
};